import {register} from '../vendor/theme-scripts/theme-sections';
import {slider} from '../features/slider';
import {quickAddProduct} from '../features/quick-add';
import {swatchGridSection} from '../features/swatch';
import tabs from '../features/tabs';

register('product-grid', [slider, quickAddProduct, swatchGridSection, tabs]);
